import { ExtraOptions, Route, RouterModule } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { NgModule } from '@angular/core';
import { canActivate, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { AdminGuard } from './core/guards/admin.guard';
import { TitleService } from './core/services/title.service';
import { TitleGuard } from './core/guards/title.guard';

const routerConfig: ExtraOptions = { scrollPositionRestoration: 'enabled' };

const redirectUnauthorizedToLogin = (route): any => {
  TitleService.title$.next(route.firstChild.routeConfig.title);
  return redirectUnauthorizedTo([ 'sign-in' ]);
};
const redirectLoggedInToItems = (): any => redirectLoggedInTo([ '' ]);

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

  // Redirect empty path to '/example'
  { path: '', pathMatch: 'full', redirectTo: 'registro-jornada' },

  // Redirect signed in user to the '/example'
  //
  // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'registro-jornada' },

  // Auth routes for guests
  {
    path: '',
    component: LayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: 'confirmation-required',
        ...canActivate(redirectLoggedInToItems),
        loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)
      },
      {
        path: 'forgot-password',
        ...canActivate(redirectLoggedInToItems),
        loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
      },
      {
        path: 'reset-password',
        ...canActivate(redirectLoggedInToItems),
        loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)
      },
      {
        path: 'sign-in',
        ...canActivate(redirectLoggedInToItems),
        loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
      },
      {
        path: 'sign-up',
        ...canActivate(redirectLoggedInToItems),
        loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)
      },
      {
        path: 'formulario-historia-clinica',
        loadChildren: () => import('app/modules/no-auth/form-history-clinic/form-history-clinic.module').then(m => m.FormHistoryClinicModule)
      }
    ]
  },

  // Auth routes for authenticated users
  {
    path: '',
    component: LayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)
      },
      {
        path: 'unlock-session',
        loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)
      }
    ]
  },

  // Admin routes
  {
    path: '',
    ...canActivate(redirectUnauthorizedToLogin),
    canActivateChild: [TitleGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/admin/home/home.module').then(m => m.HomeModule),
        title: 'Home'
      },
      {
        path: 'registro-jornada',
        loadChildren: () => import('./modules/admin/day-record/day-record.module').then(m => m.DayRecordModule),
        title: 'Registro de Jornada'
      },
      {
        canLoad: [ AdminGuard ],
        path: 'administracion',
        loadChildren: () => import('./modules/admin/administration/administration.module').then(m => m.AdministrationModule),
        title: 'Administración'
      },
      {
        path: 'clientes',
        loadChildren: () => import('./modules/admin/clients/clients.module').then(m => m.ClientsModule),
        title: 'Clientes'
      },
      {
        path: 'agenda',
        loadChildren: () => import('./modules/admin/schedule/schedule.module').then(m => m.ScheduleModule),
        title: 'Agenda'
      },
      {
        path: 'agenda2',
        loadChildren: () => import('./modules/admin/schedule2/schedule.module').then(m => m.ScheduleModule),
        title: 'Agenda'
      },
      {
        path: 'tareas',
        loadChildren: () => import('./modules/admin/tasks-boards/tasks-boards.module').then(m => m.TasksBoardsModule),
        title: 'Tareas'
      },
      {
        path: 'blog',
        loadChildren: () => import('./modules/admin/blog/blog.module').then(m => m.BlogModule),
        title: 'Blog'
      },
      {
        path: 'primeras-entrevistas',
        loadChildren: () => import('./modules/admin/first-interview/first-interview.module').then(m => m.FirstInterviewModule),
        title: 'Primeras Entrevistas'
      }
    ]
  },


  {
    path: 'nuevo-cliente',
    ...canActivate(redirectUnauthorizedToLogin),
    component: LayoutComponent,
    data: { layout: 'empty' },
    loadChildren: () => import('./modules/admin/new-client/new-client.module').then(m => m.NewClientModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, routerConfig)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}

